/* eslint-disable */

import uuidv4 from 'uuid/v4';

// key = original ID
// value = copy ID
let idLookupTable = {};

// updates any ID-based custom attributes (e.g. events) with the ID of the copied elements
function patchIds(flexObject) {
    const idAttrNames = ['dropdown-anchor-target-id', 'flex-event-group'];
    const queue = [flexObject];

    for (const flexElem of queue) {
        const attrKeys = Object.keys(flexElem.customAttributes);

        attrKeys.forEach((attrName) => {
            if (idAttrNames.includes(attrName)) {
                Object.entries(idLookupTable).forEach((entry) => {
                    const [originalId, copyId] = entry;

                    if (flexElem.customAttributes[attrName].includes(originalId)) {
                        flexElem.customAttributes[attrName] = flexElem.customAttributes[attrName].replace(new RegExp(originalId, 'g'), copyId);
                    }
                })
            }
        });

        if (flexElem.elements) {
            flexElem.elements.forEach(child => queue.push(child));
        }
    }

    return flexObject;
}

export default function flexDeepCopy(flexObject) {
    idLookupTable = {};

    function deepCopy(objOriginal) {
        const objCopy = { ...objOriginal };

        objCopy.id = uuidv4();
        objCopy.dataSourceId = '00000000-0000-0000-0000-000000000000';

        idLookupTable[objOriginal.id] = objCopy.id;

        if (objCopy.customAttributes) {
            objCopy.customAttributes = { ...objCopy.customAttributes };
        }

        if (objCopy.htmlCustomAttributes) {
            objCopy.htmlCustomAttributes = { ...objCopy.htmlCustomAttributes };
        }

        if (objCopy.elements) {
            const newElements = [];

            objCopy.elements.forEach((element) => {
                newElements.push(deepCopy(element));
            });

            objCopy.elements = newElements;
        }

        return objCopy;
    }

    return patchIds(deepCopy(flexObject));
}
